import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { loadStripe } from "@stripe/stripe-js";

// --- CONFIGURATION ---
const firebaseConfig = {
  apiKey: "AIzaSyCywNyFkicxAn1hTvcFHyn5pwSlVRJ7i-4",
  authDomain: "pixel-digital-store.firebaseapp.com",
  projectId: "pixel-digital-store",
  storageBucket: "pixel-digital-store.firebasestorage.app",
  messagingSenderId: "553751519315",
  appId: "1:553751519315:web:49efd2e85d5519887166a6",
  databaseURL: "https://pixel-digital-store-default-rtdb.firebaseio.com" // <--- FIXED: Now inside the brackets!
};

// --- INITIALIZE SERVICES ---
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app); 

// --- STRIPE ---
// ⚠️ IMPORTANT: Your previous key looked cut off at the end (L0D>). 
// Please verify this is your FULL, correct Live Key from the Stripe Dashboard.
export const stripePromise = loadStripe("pk_live_51SAmyW02LJs8AkwKAAQEI2ifzkwReh9s5yb400couwChkcVV2QhVVnRaoYzLijtqvrGn29jurI7sL0DRICYNtndz00fjR9Lwd1");

export const API_URL = "https://us-central1-pixel-digital-store.cloudfunctions.net/createPaymentIntent";
export const auth = getAuth(app);
